import { useState, useCallback } from "react";
import "./login-screen.scss";
import Button from "src/libraries/components/button/Button";
import LoginInput from "src/libraries/components/form-login/form-login";
import { useForm, FormProvider } from "react-hook-form";
import { LoginAdapter } from "./login-adapter";
import { useHistory } from "react-router-dom";

export const LoginScreen = () => {
  const history = useHistory();
  const { handleLogin } = LoginAdapter();

  const methods = useForm({
    mode: "onChange",
    criteriaMode: "all",
  });
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);

  const onSubmit = (
    event: React.MouseEvent<HTMLButtonElement>,
    data: Object
  ) => {
    event.preventDefault();
    handleLogin(data);
  };
  return (
    <div className="login-background">
      <div className="login-container">
        <div className="login-logo">
          <img
            src={require("../../assets/payment-logo.jpg")}
            alt="hyperlogy-logo"
          />
        </div>
        <div className="sign-in-form">
          <div className="form-container">
            <div className="form-top">
              <div className="form-title">
                <img
                  src={require("../../assets/hyper.jpg")}
                  alt="hyperlogy-logo"
                />
              </div>
            </div>
            <div className="form-bot">
              <FormProvider {...methods}>
                <form
                  noValidate
                  // onSubmit={methods.handleSubmit((data) => onSubmit(data))}
                >
                  <div className="form-input">
                    <LoginInput
                      name="username"
                      type="text"
                      label="User name"
                      placeholder="User name"
                      disable={false}
                      style={{
                        width: "100%",
                        height: 50,
                        fontSize: 20,
                        //boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                      }}
                      rules={{
                        required: "Bắt buộc",
                        // pattern: {
                        //   value: /^\S+@\S+\.\S+$/,
                        //   message: "Email không đúng định dạng",
                        // },
                      }}
                    />

                    <LoginInput
                      name="password"
                      type="password"
                      label="Password"
                      placeholder="Mật khẩu"
                      isPassword={true}
                      disable={false}
                      visiblePassword={isPasswordVisible}
                      setVisiblePassword={setIsPasswordVisible}
                      style={{
                        width: "100%",
                        height: 50,
                        fontSize: 20,
                        //boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                      }}
                      rules={{
                        required: "Bắt buộc",
                        minLength: {
                          value: 6,
                          message: "Cần 6 ký tự !",
                        },
                      }}
                    />
                  </div>
                  <div className="forget-password">Quên mật khẩu ?</div>
                  <div className="form-submit-btn">
                    <Button
                      children={<div style={{ fontSize: 20 }}>Đăng nhập</div>}
                      background="linear-gradient(180deg, #4697fe, #08f)"
                      textColor="white"
                      borderColor="white"
                      height={"50px"}
                      width={"100%"}
                      onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
                        onSubmit(event, methods.getValues())
                      }
                      isDisabled={false}
                      marginRight="0"
                      className="submit-button"
                      marginLeft="0"
                    />
                  </div>
                </form>
              </FormProvider>
              <div className="form-to-register">
                Chưa có tài khoản ?{" "}
                <span onClick={() => history.push("/register")}>Đăng ký</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
